/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Event_Template_ErrorInputs */

const en_context_menu_event_template_error = /** @type {(inputs: Context_Menu_Event_Template_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error creating event template`)
};

const fr_context_menu_event_template_error = /** @type {(inputs: Context_Menu_Event_Template_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la création du modèle d'événement`)
};

const de_context_menu_event_template_error = /** @type {(inputs: Context_Menu_Event_Template_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Erstellen der Ereignisvorlage`)
};

const it_context_menu_event_template_error = /** @type {(inputs: Context_Menu_Event_Template_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante la creazione del modello di evento`)
};

const ru_context_menu_event_template_error = /** @type {(inputs: Context_Menu_Event_Template_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при создании шаблона события`)
};

const es_context_menu_event_template_error = /** @type {(inputs: Context_Menu_Event_Template_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al crear la plantilla de evento`)
};

const zh_cn2_context_menu_event_template_error = /** @type {(inputs: Context_Menu_Event_Template_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建事件模板时出错`)
};

const ja_context_menu_event_template_error = /** @type {(inputs: Context_Menu_Event_Template_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント テンプレートの作成中にエラーが発生しました`)
};

const hi_context_menu_event_template_error = /** @type {(inputs: Context_Menu_Event_Template_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेम्प्लेट बनाने में त्रुटि`)
};

const pt_pt2_context_menu_event_template_error = /** @type {(inputs: Context_Menu_Event_Template_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao criar o modelo de evento`)
};

/**
* | output |
* | --- |
* | "Error creating event template" |
*
* @param {Context_Menu_Event_Template_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_event_template_error = /** @type {((inputs?: Context_Menu_Event_Template_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Event_Template_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_event_template_error(inputs)
	if (locale === "de") return de_context_menu_event_template_error(inputs)
	if (locale === "it") return it_context_menu_event_template_error(inputs)
	if (locale === "ru") return ru_context_menu_event_template_error(inputs)
	if (locale === "es") return es_context_menu_event_template_error(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_event_template_error(inputs)
	if (locale === "ja") return ja_context_menu_event_template_error(inputs)
	if (locale === "hi") return hi_context_menu_event_template_error(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_event_template_error(inputs)
	return en_context_menu_event_template_error(inputs)
});